import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, FileText, Info, X } from 'lucide-react';

export const FloatingBookButton = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  
  return (
    <div className="fixed bottom-6 left-4 right-4 sm:left-6 sm:right-auto z-50">
      {/* Mobile: Two buttons side by side */}
      <div className="flex items-center gap-3 sm:flex-row">
        {/* Devis button - Green, left side */}
        <Link
          to="/devis-premium"
          className="flex items-center gap-2 bg-[#0A2320] hover:bg-[#153254] text-white px-4 py-3 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300"
        >
          <FileText className="h-5 w-5" />
          <span className="font-semibold hidden sm:inline">Demander un devis</span>
          <span className="font-semibold sm:hidden">Devis</span>
        </Link>
        
        {/* RDV button - Gold, right side */}
        <Link
          to="/rendez-vous"
          className="flex items-center gap-2 bg-[#D4AF37] hover:bg-[#c9a030] text-white px-4 py-3 rounded-full shadow-xl hover:shadow-2xl transition-all duration-300"
        >
          <Calendar className="h-5 w-5" />
          <span className="font-semibold hidden sm:inline">Prendre RDV</span>
          <span className="font-semibold sm:hidden">RDV</span>
        </Link>
        
        {/* Info button */}
        <button
          onClick={() => setShowTooltip(!showTooltip)}
          className="w-8 h-8 bg-white border-2 border-gray-200 rounded-full flex items-center justify-center shadow-md hover:bg-gray-50 transition-colors flex-shrink-0"
        >
          {showTooltip ? (
            <X className="h-4 w-4 text-gray-500" />
          ) : (
            <Info className="h-4 w-4 text-gray-500" />
          )}
        </button>
      </div>
      
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-16 left-0 bg-white border border-gray-200 rounded-xl p-4 shadow-xl max-w-[320px]">
          <p className="text-sm text-gray-700 mb-3">
            <span className="inline-block w-3 h-3 bg-[#0A2320] rounded-full mr-2"></span>
            <span className="font-semibold text-[#0A2320]">Devis</span> : Pour une nouvelle demande de service.
          </p>
          <p className="text-sm text-gray-700">
            <span className="inline-block w-3 h-3 bg-[#D4AF37] rounded-full mr-2"></span>
            <span className="font-semibold text-[#D4AF37]">RDV</span> : Pour les personnes ayant déjà un devis validé.
          </p>
          <div className="absolute -bottom-2 left-10 w-4 h-4 bg-white border-r border-b border-gray-200 transform rotate-45"></div>
        </div>
      )}
    </div>
  );
};
